/**
 * Cover CSS/SVG « maison » de la carte MOTUS : mini-grille de tuiles façon
 * plateau, où le mot MOTUS se révèle ligne après ligne. Purement décoratif
 * (aria-hidden posé par le wrapper de GameCard) et **inventé** : aucun lien
 * avec une partie réelle — rien de secret n'atteint jamais le DOM (ADR 0003).
 *
 * Lettres uniquement sur les tuiles « correct » (panda + texte ink-950, même
 * paire que le bouton primary → lisible dans les deux thèmes) ; les tuiles
 * present/absent restent des aplats colorés.
 */

type TileState = 'correct' | 'present' | 'absent';

interface Tile {
  state: TileState;
  letter?: string;
}

const ROWS: Tile[][] = [
  [
    { state: 'correct', letter: 'M' },
    { state: 'absent' },
    { state: 'present' },
    { state: 'absent' },
    { state: 'absent' },
  ],
  [
    { state: 'correct', letter: 'M' },
    { state: 'correct', letter: 'O' },
    { state: 'absent' },
    { state: 'present' },
    { state: 'absent' },
  ],
  [
    { state: 'correct', letter: 'M' },
    { state: 'correct', letter: 'O' },
    { state: 'correct', letter: 'T' },
    { state: 'correct', letter: 'U' },
    { state: 'correct', letter: 'S' },
  ],
];

const TILE_STYLES: Record<TileState, string> = {
  correct: 'bg-motus-correct text-ink-950',
  present: 'bg-motus-present',
  // Bordure : en thème clair, --motus-absent (ink-700) est blanc → la bordure
  // garde la tuile visible sur la carte.
  absent: 'border border-ink-600/50 bg-motus-absent',
};

export function MotusCover() {
  return (
    <div className="flex h-28 items-center justify-center rounded-lg border border-ink-600/40 bg-app/60">
      <div className="grid grid-cols-5 gap-1.5">
        {ROWS.flatMap((row, r) =>
          row.map((tile, c) => (
            <span
              key={`${r}-${c}`}
              className={`flex h-7 w-7 items-center justify-center rounded-sm font-display text-sm font-bold ${TILE_STYLES[tile.state]}`}
            >
              {tile.letter ?? ''}
            </span>
          )),
        )}
      </div>
    </div>
  );
}
